<template>
    <div class="relative">
        <component
            :is="buttonComponent"
            class="button-menu cursor-pointer"
            type="button"
            :class="buttonClasses"
            :to="buttonRoute"
            v-bind="buttonHref ? {href: buttonHref} : {}"
            :replace="buttonRouteReplace"
            @click="buttonClick(buttonClickParams)"
        >
            <span class="inline-flex flex-row space-x-2 items-center">
                <component
                    v-if="buttonIcon"
                    :is="iconComponent"
                    :marginAuto="false"
                    class="text-purple-400 absolute"
                    :class="buttonIconPulse ? 'animate-pulse' : ''"
                ></component>
                <span :class="buttonIcon ? 'pl-6' : ''">{{ buttonText }}</span>
            </span>
        </component>
    </div>
</template>

<script>
export default {
    name: 'ButtonMenu',
    props: {
        buttonRoute: {
            required: false,
            type: [String, Object],
            default: null,
        },
        buttonRouteReplace: {
            required: false,
            type: Boolean,
            default: false,
        },
        buttonHref: {
            required: false,
            type: String,
            default: null,
        },
        buttonText: {
            required: false,
            type: String,
            default: null,
        },
        buttonIcon: {
            required: false,
            type: String,
            default: null,
        },
        buttonIconPulse: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        buttonClick: {
            required: false,
            type: Function,
            default: () => {},
        },
        buttonClickParams: {
            required: false,
            type: [String, Object, Array],
            default: null,
        },
    },
    computed: {
        iconComponent() {
            return 'icon-' + this.buttonIcon;
        },
        buttonComponent() {
            if (this.buttonRoute) return 'router-link';
            if (this.buttonHref) return 'a';
            return 'button';
        },
        buttonClasses() {
            const cls = {};
            cls['text-base font-bold leading-6 text-white'] = true;
            cls['-ml-2'] = !!this.buttonIcon;
            return cls;
        },
    },
};
</script>
